// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"22":"datenschutz","42":"impressum"}[chunkId] || chunkId) + "." + {"22":"24c94dcf","42":"7957ef1c","264":"31b3c30b"}[chunkId] + ".css";
};